import React from "react";
import { ModalV2 } from "@jsq/ds/core";
import { ProfileNameFields } from "~/pages/Compliance/utils/types";
import BankAccountForm from "../../../Profiles/BankAccountCard/BankAccountForm";
import { CompliancePaymentAccountType } from "../../../Profiles/BankAccountCard/EditBankAccountAction/types";
import { Profile } from "../types";

interface PaymentBeneficiaryModalProps {
  show: boolean;
  onHide: () => void;
  mode: "create" | "edit";
  profiles?: Profile[];
  investingProfile?: ProfileNameFields | null;
  compliancePaymentAccount: CompliancePaymentAccountType;
  caseId: number;
  programId?: number;
  positionId: string;
  title: string;
  createdProfile?: Profile | null;
}

const PaymentBeneficiaryModal: React.FC<PaymentBeneficiaryModalProps> = ({
  show,
  onHide,
  mode,
  profiles,
  investingProfile,
  compliancePaymentAccount,
  caseId,
  programId,
  positionId,
  title,
  createdProfile,
}) => {
  return (
    <ModalV2 show={show} onHide={onHide} title={`${title} Payment Beneficiary`}>
      <ModalV2.Body>
        <BankAccountForm
          caseId={caseId}
          positionId={positionId}
          mode={mode}
          onExit={onHide}
          showBankAndCountry={false}
          showingInModal
          profiles={profiles}
          programId={programId}
          investingProfile={investingProfile}
          compliancePaymentAccount={compliancePaymentAccount}
          label="Payment beneficiary"
          createdProfile={createdProfile}
        />
      </ModalV2.Body>
    </ModalV2>
  );
};

export default PaymentBeneficiaryModal;
